module.exports = __webpack_public_path__ + "media/images/sec_5-1-9cf0a985706aff68c13635239e35cccc.png";